import {Component, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {PopUpWindowComponent} from "./pop-up-window/pop-up-window.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
    selector: 'app-pop-up',
    templateUrl: './pop-up.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./pop-up.component.scss'],

})
export class PopUpComponent implements OnInit {
  private dialog = inject(MatDialog);


  @Input() header: string = "Header";
  @Input() message: string = "Message";
  @Input() approveButtonName: string = "Button";
  @Input() holdable: boolean = false;

  @Output () approvedPressed = new EventEmitter<void>();
  @Output () declinedPressed = new EventEmitter<void>();

  ngOnInit(): void {
    let dialogRef = this.dialog.open(PopUpWindowComponent, {
      panelClass:"rounded-corners-dialog",
      data: {
        //header: this.header,
        message: this.message,
        approveButtonName: this.approveButtonName,
        holdable: this.holdable
      },
      hasBackdrop: true,
      disableClose: true,
      width: '512px',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.approvePressed) {
        this.approvedPressed.emit();
      } else {
        this.declinedPressed.emit();
      }
    });
  }

}
